import normalHearingIcon from './normal.webp';
import mildHearingIcon from './mild.webp';
import severeHearingIcon from './severe.webp';
import infoIcon from './info-icon.png';
export var eargoImages = {
    normalHearingIcon: normalHearingIcon,
    mildHearingIcon: mildHearingIcon,
    severeHearingIcon: severeHearingIcon,
    infoIcon: infoIcon,
};
